import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'
import mapCampaignLinkFormToPayload from './mapCampaignLinkFormToPayload'

const updateCampaignLink = async (id, formValues) => {
  try {
    const callable = functions.httpsCallable('updateCampaignLink')
    const result = await callable({
      id,
      ...mapCampaignLinkFormToPayload(formValues),
    })

    return {
      ok: true,
      data: result.data,
    }
  } catch (error) {
    console.error('[updateCampaignLink] failed:', error)

    const code = typeof error?.code === 'string' ? error.code.replace('functions/', '') : ''
    const message =
      code === 'not-found'
        ? 'Посилання не знайдено'
        : getCallableErrorMessage(error)

    return {
      ok: false,
      message,
    }
  }
}

export default updateCampaignLink
